import i18next from 'i18next';
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomModal from '~components/CustomModal';
import { MODALS } from '~redux/Modal/constants';
import ModalActions from '~redux/Modal/actions';
import SearchSelect from '~components/SearchSelect';
import SearchStoreActions from '~redux/SearchStore/actions';
import LocalStorageService from '~services/LocalStorageService';

import styles from './styles.module.scss';
import { COMMUNES, TEXTS, STORE_COMMUNE_MAPPER } from './constants';

const PickCommuneModal = () => {
  const open = useSelector((state) => state.modal[`${MODALS.PICK_COMMUNE}ModalIsOpen`]);
  const { currentSubsidiary, stores } = useSelector((state) => state.searchStore);
  const { hasCommuneFirstSetup } = useSelector((state) => state.core.settings);
  const dispatch = useDispatch();
  const commune = LocalStorageService.getCommune();

  useEffect(() => {
    if (!commune && hasCommuneFirstSetup) {
      dispatch(ModalActions.openModal(MODALS.PICK_COMMUNE));
    } else {
      dispatch(ModalActions.closeModal(MODALS.PICK_COMMUNE));
    }
  }, [commune, currentSubsidiary, dispatch, hasCommuneFirstSetup]);

  const Communes = useMemo(() => COMMUNES.map(({ name, code }) => ({ label: name, value: code })), []);

  const handleSelect = (option) => {
    dispatch(SearchStoreActions.getStoresByCommune(STORE_COMMUNE_MAPPER[option.label]));
  };

  const handleClick = () => {
    dispatch(SearchStoreActions.selectSubsidiary(stores?.page?.[0]));
    LocalStorageService.setCommune(true);
  };

  return (
    <CustomModal
      modal={MODALS.PICK_COMMUNE}
      className={`column space-around ${styles.modal}`}
      isOpen={open}
      shouldCloseOnOverlayClick={false}
      hideCloseButton>
      {TEXTS.map(({ text, className, component: Component }) => (
        <Component className={className} key={text}>
          {i18next.t(`PickCommune:${text}`)}
        </Component>
      ))}
      <SearchSelect
        title={i18next.t('PickCommune:selectCommune')}
        placeholder={i18next.t('PickCommune:enterCommune')}
        showArrow
        options={Communes}
        optionClassName={styles.option}
        onSelect={handleSelect}
      />
      <button disabled={!stores?.page?.length} className={styles.button} type="button" onClick={handleClick}>
        {i18next.t('PickCommune:confirm')}
      </button>
    </CustomModal>
  );
};

export default PickCommuneModal;
